import "./index.css";

import { createBrowserRouter } from "react-router";
import { RouterProvider } from "react-router/dom";
import { AuthGuard } from "@repo/auth";
import { Home } from "./routes/home";
import { NotFound } from "@repo/ui";

const router = createBrowserRouter([
  // Route candidat — authentification légère (evaluationId + nom de famille)
  {
    path: "/e/:id",
    element: <AuthGuard />,
    children: [
      {
        index: true,
        element: <Home />,
      },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
]);

export function App() {
  return <RouterProvider router={router} />;
}

export default App;
